import React from 'react';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { shape, bool as boolType } from 'prop-types';
import styles from './RecommendationsProductPodCarousel.module.scss';

const cx = classNames.bind(styles);

const CollectionsImage = ({ metadata, firstProductMedia, isMobile }) => {
  const firstProductImage = firstProductMedia?.images[0].url.replace(/<SIZE>/g, '600');

  return (
    <Col xs="4" className={cx('carouselAnchorImage')}>
      <div className="battery-systems__feature--img">
        {metadata?.collectionImageUrl ? (
          <Image
            src={metadata?.collectionImageUrl}
            alt="main-product-image"
            height="300"
            width="300"
            data-testid="anchor-image"
          />
        ) : (
          <Image
            src={firstProductImage}
            aria-label="firstProductImage"
            alt="first-product-image"
            height="300"
            width="300"
          />
        )}
      </div>
      <div className="battery-systems__feature--list">
        {/* eslint-disable-next-line react/no-danger */}
        <ul dangerouslySetInnerHTML={{ __html: metadata?.collectionDesc }} />
      </div>
      {metadata?.collectionPlpUrl && (
        <div className="battery-systems__shop--link">
          <a
            href={metadata?.collectionPlpUrl}
            rel="noreferrer"
            target={isMobile ? '_self' : '_blank'}
            data-testid="tooltip-product"
          > Shop {metadata?.collectionName}
          </a>
        </div>
      )}
    </Col>
  );
};

CollectionsImage.propTypes = {
  metadata: shape({
  }),
  firstProductMedia: shape({
  }),
  isMobile: boolType
};

CollectionsImage.defaultProps = {
  metadata: {},
  firstProductMedia: {},
  isMobile: false
};

export default CollectionsImage;